import { useEffect, useRef, useState } from "react";
import Pagination from "../../common/Pagination/index.js";
import { MdAdd, MdDeleteForever } from "react-icons/md";
import { BiSolidEditAlt } from "react-icons/bi";
import Loader from "../../common/Loader/index.js";
import { useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../../api/axiosInstance.js";
import { RiFilter2Fill } from "react-icons/ri";
import { notify, Toast } from "../../common/Toast/index.js";
import Model from "../../common/Model/index.js";
import formatDateIndian from "../../common/formatDateIndian.js";
import { getUserMenuPermission } from "../../common/Helper/index.js";
import { FaRegEye } from "react-icons/fa";
import Filter from "../../common/Filter/index.js";
import { SiTestrail } from "react-icons/si";

const Sitedetails = () => {
  const location = useLocation();
  const passedData = location.state?.dashboardSiteData || (Array.isArray(location.state?.siteData) ? location.state.siteData : []);
  const isFilteredFromDashboard =
    location.state?.isFilteredFromDashboard || false;
  const totalPassedRecords = location.state?.totalRecords || 0;
  const permission = getUserMenuPermission(7);
  const [isSiteData, setIsSiteData] = useState([]);
  const navigate = useNavigate();
  const [salePersons, setSalePersons] = useState([]);
  const [loading, setLoading] = useState(true);
  const pageSize = 10;
  const [totalPages, setTotalPages] = useState(1);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isModal, setIsModal] = useState(false);
  const filterBtnRef = useRef(null);
  const [deleteSiteId, setDeleteSiteId] = useState(null);

  const [initialized, setInitialized] = useState(false);
  const userId = localStorage.getItem("userId");
  const FILTER_STORAGE_KEY = "site_details_filters";

  const getStoredFilters = () => {
    try {
      const stored = sessionStorage.getItem(FILTER_STORAGE_KEY);
      return stored
        ? JSON.parse(stored)
        : {
          filters: {
            siteName: "",
            ownerName: "",
            salePerson: "",
          },
          appliedFilters: {
            siteName: "",
            ownerName: "",
            salePerson: "",
          },
          currentPage: 1,
        };
    } catch {
      return {
        filters: {
          siteName: "",
          ownerName: "",
          salePerson: "",
        },
        appliedFilters: {
          siteName: "",
          ownerName: "",
          salePerson: "",
        },
        currentPage: 1,
      };
    }
  };

  const storedFilterState = getStoredFilters();
  const [filters, setFilters] = useState(location.state?.filters || {
    siteName: "",
    ownerName: "",
    salePerson: "",
  });
  const [appliedFilters, setAppliedFilters] = useState(location.state?.appliedFilters || {
    siteName: "",
    ownerName: "",
    salePerson: "",
  });
  const [currentPage, setCurrentPage] = useState(
    location.state?.currentPage || storedFilterState.currentPage || 1
  );


  useEffect(() => {
    sessionStorage.setItem(
      FILTER_STORAGE_KEY,
      JSON.stringify({
        filters,
        appliedFilters,
        currentPage,
      })
    );
  }, [filters, appliedFilters, currentPage]);

  useEffect(() => {
    if (!initialized) {
      if (isFilteredFromDashboard && passedData.length > 0) {
        setIsSiteData(passedData);
        // setTotalRecords(passedData.length);
        setLoading(false);
      } else {
        fetchSiteData();
      }
      setInitialized(true);
    }
  }, [initialized, isFilteredFromDashboard, passedData]);

  useEffect(() => {
    const fetchSalePersons = async () => {
      try {
        const res = await axiosInstance.get("User/GetAllUser");
        const salesData = res.data.map((person) => ({
          sale_Person_Id: Number(person.sale_Person_Id),
          Sale_Person_Name: person.Sale_Person_Name,
        }));

        setSalePersons(salesData);
      } catch (error) {
        notify("Error fetching sale persons:", error);
      }
    };

    fetchSalePersons();
  }, []);

  const fetchSiteData = async () => {
    try {
      setLoading(true);

      const hasFilters = Object.values(appliedFilters).some(
        (val) => val.trim() !== ""
      );

      const res = await axiosInstance.post("SiteDetail/GetAll", {
        pageNumber: currentPage,
        pageSize,
        site_Name: appliedFilters.siteName,
        owner_Name: appliedFilters.ownerName,
        sale_Person_Id: hasFilters
          ? appliedFilters.salePerson
            ? Number(appliedFilters.salePerson)
            : null
          : 0,
      });

      setIsSiteData(res.data.deals);
      setTotalRecords(res.data.total_Records);
      setTotalPages(Math.ceil(res.data.total_Records / pageSize));
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   fetchSiteData();
  // }, [currentPage, appliedFilters]);

  useEffect(() => {
    if (!isFilteredFromDashboard) {
      fetchSiteData();
    }
  }, [currentPage, appliedFilters]);

  const handleEdit = async (siteId) => {
    try {
      setLoading(true);
      const { data } = await axiosInstance.get(
        `SiteDetail/GetDealById/${siteId}`
      );
      notify("Site details loaded for editing.", "success");
      navigate("/transaction/site-details", {
        state: {
          siteData: data,
          currentPage,
          filters,
          appliedFilters,
          isFilteredFromDashboard,
          dashboardSiteData: isFilteredFromDashboard ? passedData : null,
          totalRecords: isFilteredFromDashboard ? totalPassedRecords : totalRecords
        }
      });
    } catch (error) {
      notify("Error fetching site details:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = (siteId) => {
    setDeleteSiteId(siteId);
    setIsModal(true);
  };

  const handleConfirmDelete = async () => {
    if (!deleteSiteId) return;

    try {
      await axiosInstance.delete(`SiteDetail/Delete/${deleteSiteId}`);
      setAppliedFilters({ ...appliedFilters });
      notify("SiteDetail deleted successfully!", "error");
    } catch (err) {
      notify("Error deleting site detail:", err);
    } finally {
      setIsModal(false);
      setDeleteSiteId(null);
    }
  };

  const applyFilters = () => {
    if (isFilteredFromDashboard) return;
    setAppliedFilters(filters);
    setCurrentPage(1);
    setIsFilterOpen(false);
  };

  const clearFilters = () => {
    const emptyFilters = { siteName: "", ownerName: "", salePerson: "" };

    setFilters(emptyFilters);
    setAppliedFilters(emptyFilters);
    setCurrentPage(1);

    sessionStorage.removeItem(FILTER_STORAGE_KEY);
  }; const hasActiveFilters = Object.values(appliedFilters).some(
    (val) => String(val || "").trim() !== ""
  );

  const saleOptions = [
    ...salePersons.map((per) => ({
      value: per.sale_Person_Id?.toString() || "",
      label: per.Sale_Person_Name || "Unnamed Sales",
    })),
  ];

  const handleView = async (siteId) => {
    try {
      setLoading(true);
      const { data } = await axiosInstance.get(
        `SiteDetail/GetDealById/${siteId}`
      );
      navigate("/transaction/siteview-details", {
        state: {
          siteData: data,
          currentPage,
          filters,
          appliedFilters,
          isFilteredFromDashboard,
          dashboardSiteData: isFilteredFromDashboard ? passedData : null,
          totalRecords: isFilteredFromDashboard ? totalPassedRecords : totalRecords
        }
      });
    } catch (error) {
      notify("Error fetching site details", "error");
    } finally {
      setLoading(false);
    }
  };

  const filterFields = [
    {
      label: "Site Name",
      name: "siteName",
      type: "text",
      placeholder: "Search site name",
    },
    {
      label: "Sale Person Name",
      name: "salePerson",
      type: "select",
      options: saleOptions,
    },
    {
      label: "Owner Name",
      name: "ownerName",
      type: "text",
      placeholder: "Search Owner Name",
    },
  ];

  return (
    <>
      <Toast />
      <div>
        <div className="rounded-3xl bg-transparent px-2 pt-2 pb-6">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6 mb-8">
            <div className="flex flex-col">
              <h2 className="text-2xl font-black text-slate-800 tracking-tight flex items-center gap-3">
                <div className="w-10 h-10 bg-primary/10 rounded-xl flex items-center justify-center text-primary">
                  <SiTestrail className="text-[22px]" />
                </div>
                Project Sites
              </h2>
              <p className="text-sm font-medium text-slate-400 mt-1 ml-13">Manage and monitor all active project locations and client sites</p>
            </div>

            <div className="flex items-center gap-3 w-full md:w-auto">
              {permission.isInsert && (
                <button
                  className="flex-1 md:flex-none flex items-center justify-center gap-2 bg-primary text-white px-8 py-3 rounded-2xl font-black text-xs uppercase tracking-widest shadow-[0_10px_30px_-10px_rgba(64,81,137,0.5)] hover:scale-[1.02] active:scale-[0.98] transition-all"
                  onClick={() => navigate("/transaction/site-details", {
                    state: {
                      currentPage,
                      filters,
                      appliedFilters,
                      isFilteredFromDashboard,
                      dashboardSiteData: isFilteredFromDashboard ? passedData : null,
                      totalRecords: isFilteredFromDashboard ? totalPassedRecords : totalRecords
                    }
                  })}
                >
                  <MdAdd className="text-lg" /> Add New Site
                </button>
              )}
              <button
                ref={filterBtnRef}
                className={`relative flex items-center justify-center gap-2 px-6 py-3 rounded-2xl font-black text-xs uppercase tracking-widest transition-all shadow-sm ${hasActiveFilters
                  ? "bg-primary/10 border border-primary/30 text-primary"
                  : "bg-white border border-slate-200 text-slate-600 hover:bg-slate-50"
                  }`}
                onClick={() => setIsFilterOpen((prev) => !prev)}
              >
                <RiFilter2Fill className={`text-lg ${hasActiveFilters ? "text-primary" : "text-primary"}`} />
                <span>{hasActiveFilters ? "Filters Applied" : "Filters"}</span>

                {hasActiveFilters && (
                  <span className="absolute -top-1 -right-1 min-w-[20px] h-5 px-1 bg-primary text-white text-[10px] rounded-full flex items-center justify-center">
                    {
                      Object.values(appliedFilters).filter(
                        (val) => String(val || "").trim() !== ""
                      ).length
                    }
                  </span>
                )}
              </button>
            </div>
          </div>

          <Filter
            isOpen={isFilterOpen}
            onClose={() => setIsFilterOpen(false)}
            filterFields={filterFields}
            filters={filters}
            setFilters={setFilters}
            applyFilters={applyFilters}
            clearFilters={clearFilters}
          />

          <div className="premium-card overflow-hidden border-none shadow-xl shadow-gray-200/50">
            {loading ? (
              <div className="p-20 flex justify-center"><Loader /></div>
            ) : permission.isView ? (
              <div className="overflow-x-auto">
                <table className="w-full text-sm text-left">
                  <thead className="bg-[#f9fafc] text-[#405189] uppercase tracking-wider text-[11px] font-bold border-b border-gray-100">
                    <tr>
                      <th className="px-6 py-4">Site Name</th>
                      <th className="px-6 py-4">Type</th>
                      <th className="px-6 py-4">Owner</th>
                      <th className="px-6 py-4">Sales Person</th>
                      <th className="px-6 py-4">Created Date</th>
                      <th className="px-6 py-4 text-center">Actions</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-50 bg-white">
                    {isSiteData?.length > 0 ? (
                      isSiteData?.map((site) => (
                        <tr
                          key={site.site_Id}
                          className="hover:bg-blue-50/30 transition-colors group cursor-pointer"
                        >
                          <td className="px-6 py-4 font-bold text-gray-800">
                            {site.site_Name}
                          </td>
                          <td className="px-6 py-4">
                            <span className="px-2 py-1 bg-gray-100 text-gray-600 rounded-md text-[11px] font-bold uppercase">
                              {site.site_Type}
                            </span>
                          </td>
                          <td className="px-6 py-4 text-gray-600 font-medium">
                            {site.owner_Name}
                          </td>
                          <td className="px-6 py-4">
                            <div className="flex items-center gap-2">
                              <div className="w-7 h-7 bg-primary/10 text-primary rounded-full flex items-center justify-center text-[10px] font-bold">
                                {salePersons.find(sp => Number(sp.sale_Person_Id) === Number(site.sale_Person_Id))?.Sale_Person_Name?.charAt(0) || "U"}
                              </div>
                              <span className="text-gray-700 font-semibold">
                                {salePersons.find(sp => Number(sp.sale_Person_Id) === Number(site.sale_Person_Id))?.Sale_Person_Name || "-"}
                              </span>
                            </div>
                          </td>
                          <td className="px-6 py-4 text-gray-500 font-medium whitespace-nowrap">
                            {formatDateIndian(site.created_Date)}
                          </td>
                          <td className="px-6 py-4">
                            <div className="flex items-center justify-center gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
                              <button
                                className="p-2 bg-gray-50 text-gray-600 hover:bg-primary/10 hover:text-primary rounded-lg transition-colors"
                                onClick={(e) => { e.stopPropagation(); handleView(site.site_Id); }}
                                title="View Details"
                              >
                                <FaRegEye className="w-4 h-4" />
                              </button>
                              {permission.isUpdate && (
                                <button
                                  className="p-2 bg-gray-50 text-gray-600 hover:bg-blue-50 hover:text-blue-600 rounded-lg transition-colors"
                                  onClick={(e) => { e.stopPropagation(); handleEdit(site.site_Id); }}
                                  title="Edit Site"
                                >
                                  <BiSolidEditAlt className="w-4 h-4" />
                                </button>
                              )}
                              {permission.isDelete && (
                                <button
                                  className="p-2 bg-gray-50 text-red-400 hover:bg-red-50 hover:text-red-600 rounded-lg transition-colors"
                                  onClick={(e) => { e.stopPropagation(); handleDelete(site.site_Id); }}
                                  title="Delete Site"
                                >
                                  <MdDeleteForever className="w-4 h-4" />
                                </button>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6" className="text-center py-20 text-gray-400 font-medium">
                          No project sites found in this view.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="text-center text-red-500 text-lg py-20 font-bold bg-white">
                Access Denied: You don't have permission to view site details.
              </div>
            )}

            <div className="bg-[#f9fafc] px-6 py-4 border-t border-gray-100 flex flex-col sm:flex-row justify-between items-center gap-4">
              <p className="text-[13px] text-gray-500 font-medium">
                Showing <span className="font-bold text-gray-800">
                  {isSiteData?.length > 0 ? (currentPage - 1) * pageSize + 1 : 0} to {Math.min(currentPage * pageSize, totalRecords)}
                </span> of{" "}
                <span className="font-bold text-gray-800">{totalRecords}</span> records
              </p>
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={setCurrentPage}
              />
            </div>
          </div>
        </div>
      </div>

      <Model isOpen={isModal} onClose={() => setIsModal(false)}>
        <div className="p-8 text-center">
          <div className="w-16 h-16 bg-red-50 text-red-500 rounded-full flex items-center justify-center mx-auto mb-4">
            <MdDeleteForever className="w-8 h-8" />
          </div>
          <h3 className="text-xl font-bold text-gray-800 mb-2">Confirm Delete</h3>
          <p className="text-gray-500 mb-8 max-w-[300px] mx-auto">
            Are you sure you want to permanently delete this site? This action cannot be undone.
          </p>
          <div className="flex justify-center gap-3">
            <button
              className="px-6 py-2.5 rounded-xl font-bold text-gray-600 bg-gray-100 hover:bg-gray-200 transition-colors"
              onClick={() => setIsModal(false)}
            >
              Cancel
            </button>
            <button
              className="px-6 py-2.5 rounded-xl font-bold text-white bg-red-500 hover:bg-red-600 shadow-lg shadow-red-200 transition-all active:scale-95"
              onClick={handleConfirmDelete}
            >
              Delete Site
            </button>
          </div>
        </div>
      </Model>
    </>
  );
};

export default Sitedetails;
